import React from "react"
import { useTranslation } from "react-i18next"
import { Note, Status, Message } from "./styled/TimelineEventDetails"
import { formatWithDateTime } from "../../helpers/translation"

const DownloadDetails = ({
  isDownloaded,
  isExpired,
  fromEmail,
  message,
  availableUntil,
}) => {
  const { t, i18n: { language } } = useTranslation("generic")

  return (
    <>
      <div>
        {!isDownloaded && <Status $isNew={true}>{t("##.Transfers.New")}</Status>}
        {isExpired && (
          <Status $isExpired={true}>{t("##.Transfers.Expired")}</Status>
        )}
      </div>
      <span>{fromEmail}</span>
      {!!message && <Message>"{message}"</Message>}
      <Note>
        {formatWithDateTime(language, t("##.Transfers.AvailableUntilShort"), availableUntil)}
      </Note>
    </>
  )
}

export default DownloadDetails
